import React from "react";
import { sidemenuFooterWrap } from "../componentCommon";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import "../../index.scss";
import "./Responsive.scss";
import "./AboutProject.scss";

const AboutProjectText = () => (
  <div className="about-project-text">
    <Row>
      <Col
        sm={{ span: 12 }}
        md={{ span: 11, offset: 1 }}
        lg={{ span: 11, offset: 1 }}
        xl={{ span: 11, offset: 0 }}
      >
        <b>
          Saznajte sad više o projektu Čitajte o... iz tekstova objavljenih u
          stručnim časopisima i prezentovanih na Medjunarodnim skupovima
        </b>
        <br />
        <br />
        <a
          href="http://elib.mi.sanu.ac.rs/files/journals/ncd/15/ncd15077.pdf"
          target="_blank"
          rel="noreferrer"
        >
          <b>
            READ ABOUT… Project of Digitization of Art Documentation Department,
            Museum of Contemporary Art, Belgrade
          </b>
          , Aleksandra Mirčić and Nenad Jeremić
        </a>
        <br />
        Rad je prezentovan na The fourth SEEDI International Conference:
        Digitization of cultural and scientific heritage, June 12-15, 2008,
        Belgrade, Serbia, objavljen u elektrinskom časopisu
        <a
          href="http://elib.mi.sanu.ac.rs/pages/browse_issue.php?db=ncd&amp;rbr=1&amp;start=0"
          target="_blank"
          rel="noreferrer"
        >
          Review of the National Center for Digitization Publisher: Faculty of
          Mathematics, Belgrade ISSN: 1820-0109, Issue: 15, Date: 2009.
        </a>
        <br />
        <br />
        <a href="http://www.citajteo.rs/znacaj_standarda.pdf" target="_blank">
          Značaj standarda za elektronsku biblioteku na primeru elektronske
          čitaonice “Čitajte o...”, Aleksandra Mirčić, Katarina Jaić
          <br />
        </a>
        Rad prezentovan na Međunarodnoj naučnoj konferenciji “Elektronske
        biblioteke” održane od 25-28. septembra 2009 u Beogradu i objavljen u
        zborniku radova sa navedene konferencije
        <br />
        <br />
        <strong>Autor projekta</strong>: Aleksandra Mirčić
        <br />
        <strong>
          Kustos projekta <i>Čitajte o MSUB</i>
        </strong>
        : Katarina Krstić
        <br />
        <strong>Odeljenje za umetničku dokumentaciju</strong>: Divna Matić, Nedija Kovačević, Jelena Radović
        <br />
        <strong>Programiranje</strong>: Nenad Jeremić, Srđan Đukić
        <br />
        <strong>Stručni savetnik</strong>: Katarina Jaić
        <br />
        <strong>Dizajn</strong>: Andrej Dolinka
        <br />
        <strong>Saradnici</strong>: Vuk Jovanović, Milica Vučetić, Neda Radoičić, Olivera Nastić, Vlada Todosijević, Danica Đorđević
        <br />
      </Col>
    </Row>
  </div>
);

const AboutProject = sidemenuFooterWrap(AboutProjectText);
export default AboutProject;
